import Header from "./components/Header";
import Hero from "./components/Hero";
import EventHub from "./components/EventHub";
import ArchetypeFiles from "./components/ArchetypeFiles";
import CrashFlow from "./components/CrashFlow";
import DeepDives from "./components/DeepDives";
import Faq from "./components/Faq";
import Newsletter from "./components/Newsletter";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <EventHub />
        <ArchetypeFiles />
        <CrashFlow />
        <DeepDives />
        <Faq />
        <Newsletter />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}